/* --- pn tab switching --- */
(function(){
  var tabs = document.querySelectorAll('.syb-lp .pn-tab');
  if(!tabs.length) return;
  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      var target = this.getAttribute('data-pntab');
      tabs.forEach(function(t){ t.classList.remove('is-active'); });
      document.querySelectorAll('.syb-lp .pn-panel').forEach(function(p){ p.classList.remove('is-active'); });
      this.classList.add('is-active');
      var panel = document.getElementById('pntab-' + target);
      if(panel) panel.classList.add('is-active');
    });
  });
})();

/* --- pn swiper init + arrow positioning --- */
(function(){

  var _retries = 0;

  /* 矢印をrow1とrow2のギャップ中央にDOM計測で配置 */
  function positionPnArrows(swiperEl) {
    if (window.innerWidth > 750) return;
    var slide = swiperEl.querySelector('.swiper-slide');
    if (!slide) return;
    var grid = slide.querySelector('.pn-grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('.pn-card');
    if (cards.length < 3) return;
    var swiperRect = swiperEl.getBoundingClientRect();
    /* panel が display:none の場合は height===0 なのでスキップ */
    if (swiperRect.width === 0 && swiperRect.height === 0) return;
    var row1Bot = cards[0].getBoundingClientRect().bottom;
    var row2Top = cards[2].getBoundingClientRect().top;
    var gapMid = (row1Bot + row2Top) / 2 - swiperRect.top;
    var prev = swiperEl.querySelector('.swiper-button-prev');
    var next = swiperEl.querySelector('.swiper-button-next');
    if (prev) { prev.style.top = gapMid + 'px'; prev.style.transform = 'translateY(-50%)'; prev.style.marginTop = '0'; }
    if (next) { next.style.top = gapMid + 'px'; next.style.transform = 'translateY(-50%)'; next.style.marginTop = '0'; }
  }

  function initPnSwipers() {
    /* Swiperがまだ読み込まれていない場合は最大15回リトライ */
    if (typeof Swiper === 'undefined') {
      if (++_retries <= 15) setTimeout(initPnSwipers, 200);
      return;
    }
    _retries = 0;
    if (window.innerWidth > 750) return;
    document.querySelectorAll('.syb-lp .pn-grid-swiper').forEach(function(el) {
      if (el.__pnInited) return;
      el.__pnInited = true;
      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: el.parentElement.querySelector('.swiper-button-next'),
          prevEl: el.parentElement.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: el.parentElement.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
      /* Swiper描画後に矢印を正確配置 */
      var _el = el;
      setTimeout(function() { positionPnArrows(_el); }, 50);
    });
  }

  document.querySelectorAll('.syb-lp .pn-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      setTimeout(function() {
        initPnSwipers();
        /* タブ切替後、表示中の全swiperで矢印を再配置 */
        document.querySelectorAll('.syb-lp .pn-grid-swiper').forEach(function(el) {
          if (el.__pnInited) positionPnArrows(el);
        });
      }, 50);
    });
  });

  /* スクロール時：リスナーを削除せず毎回試みる（未inited分があれば初期化） */
  window.addEventListener('scroll', initPnSwipers, { passive: true });

  /* ページ読み込み完了時 */
  window.addEventListener('load', initPnSwipers);

  /* セクションが画面に入った瞬間に初期化（スクロールなし訪問対策） */
  if ('IntersectionObserver' in window) {
    var _pnTarget = document.querySelector('.syb-lp .pn-tabs-wrap');
    if (_pnTarget) {
      new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) initPnSwipers();
      }, { threshold: 0 }).observe(_pnTarget);
    }
  }

})();

/* --- ticker / voice swiper init + FAQ accordion --- */
window.addEventListener('load', () => {

  function lazyInitSwiper(el, options) {

    if (!el) return;
    if (el.__inited) return;
    if (typeof Swiper === 'undefined') return;

    const build = () => {
      if (el.__inited) return;
      el.__inited = true;
      new Swiper(el, options);
    };

    const rect = el.getBoundingClientRect();
    const inView = rect.top < (window.innerHeight || document.documentElement.clientHeight);
    if (inView && document.readyState === 'complete') { build(); return; }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          build();
          io.disconnect();
        }
      });
    }, { rootMargin: '200px' });
    io.observe(el);
  }

  const productSliderContent = document.querySelector('#productSwiper');
  const voiceSliderContent = document.querySelector('#voiceSwiper');

  if (productSliderContent) {
    lazyInitSwiper(productSliderContent, {
      loop: true,
      loopedSlides: 13,
      spaceBetween: 6,
      slidesPerView: 'auto',
      speed: 5000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      breakpoints: {
        768: { slidesPerView: 'auto', spaceBetween: 24 }
      }
    });
  }

  if (voiceSliderContent) {
    lazyInitSwiper(voiceSliderContent, {
      observer: true,
      observeParents: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      slidesPerView: 'auto',
      initialSlide: 1,
      loop: false,
      navigation: { nextEl: '#voiceSwiper .swiper-button-next', prevEl: '#voiceSwiper .swiper-button-prev' },
      pagination: { el: '.voice1 .swiper-pagination', clickable: true },
      spaceBetween: 16,
      breakpoints: {
        768: { centeredSlides: false, slidesPerView: 'auto', spaceBetween: 24 },
        1200: { centeredSlides: false, slidesPerView: 'auto', spaceBetween: 42 }
      }
    });
  }

  const faqContent = document.querySelector('.faqs');
  if (faqContent) {
    const faqButtons = document.querySelectorAll('.item .js-plus');
    if (faqButtons.length > 0) {
      faqButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const parent = button.closest('.item');
          const faqBody = parent.querySelector('div.b');
          if (!parent.classList.contains('on')) {
            parent.classList.add('on');
            faqBody.style.height = faqBody.scrollHeight + 'px';
          } else {
            parent.classList.remove('on');
            faqBody.style.height = 0;
          }
        })
      })
    }
  }
});

/* --- anchor scroll with header offset --- */
(() => {
  const DEBUG = /(?:^|[?&])anchorDebug=1(?:&|$)/.test(location.search) || window.__ANCHOR_DEBUG__ === true;
  const TAG = '[ANCHOR]';
  const TABLET_BASE_OFFSET = 88;
  const DESKTOP_WIDE_EXTRA_OFFSET = 8;
  const MOBILE_BASE_OFFSET = 72;

  const log = (...args) => {
    if (!DEBUG) return;
    console.log(TAG, ...args);
  };

  const getHeaderOffset = () => {
    let fixedHeaderHeight = 0;
    const selectors = [
      'header',
      '#shopify-section-header',
      '.shopify-section-header',
      '.header-wrapper',
      '.site-header'
    ];
    selectors.forEach((selector) => {
      const element = document.querySelector(selector);
      if (!element) return;
      const style = getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      if (style.position === 'fixed' || style.position === 'sticky') {
        fixedHeaderHeight = Math.max(fixedHeaderHeight, Math.round(element.getBoundingClientRect().height));
      }
    });
    return fixedHeaderHeight;
  };

  const getOffsetTop = () => {
    const headerOffset = getHeaderOffset();
    if (window.innerWidth >= 1024) {
      return Math.max(MOBILE_BASE_OFFSET, headerOffset + DESKTOP_WIDE_EXTRA_OFFSET);
    }
    if (window.innerWidth >= 768) {
      return Math.max(TABLET_BASE_OFFSET, headerOffset);
    }
    return Math.max(MOBILE_BASE_OFFSET, headerOffset);
  };

  const scrollToTarget = (targetSelector, behavior = 'auto') => {
    const target = document.querySelector(targetSelector);
    if (!target) return;

    const nextTop = window.pageYOffset + target.getBoundingClientRect().top - getOffsetTop();
    window.scrollTo({ top: nextTop, behavior });
    log('scrollToTarget', {
      targetSelector,
      behavior,
      offset: getOffsetTop()
    });
  };

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('[data-scroll-target]');
    if (!anchor) return;

    const targetSelector = anchor.getAttribute('data-scroll-target');
    if (!targetSelector) return;

    event.preventDefault();
    window.setTimeout(() => scrollToTarget(targetSelector, 'auto'), 80);
  });
})();
